import React, { useState } from "react";
import VideoMeeting from "./VideoMeeting"; // Assuming VideoMeeting handles the video call

function MeetingHome() {
  const [roomID, setRoomID] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isJoining, setIsJoining] = useState(false);

  const handleJoinOrCreate = (join) => {
    setIsJoining(join);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setRoomID("");
  };

  const startMeeting = () => {
    if (roomID.trim()) {
      setShowModal(false);
      setIsJoining(true);
    }
  };

  if (isJoining) {
    return <VideoMeeting roomID={roomID} />;
  }

  return (
    <div className="flex flex-col items-center justify-center h-[70vh] bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-6">
          Meeting Dashboard
        </h1>
        <button
          onClick={() => handleJoinOrCreate(true)}
          className="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg shadow mr-4 transition duration-300"
        >
          Join a Meeting
        </button>
        <button
          onClick={() => handleJoinOrCreate(false)}
          className="bg-green-500 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg shadow transition duration-300"
        >
          Create a Meeting
        </button>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl p-6 max-w-lg w-full">
            <h2 className="text-xl font-semibold text-gray-800">
              {isJoining ? "Join a Meeting" : "Create a Meeting"}
            </h2>
            <input
              type="text"
              className="mt-4 p-2 w-full border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder={isJoining ? "Enter Room ID" : "Set Room ID"}
              value={roomID}
              onChange={(e) => setRoomID(e.target.value)}
            />
            <div className="flex justify-end items-center mt-4">
              <button
                onClick={closeModal}
                className="text-gray-600 hover:text-gray-800 font-semibold py-2 px-4 rounded-lg mr-3 transition duration-300"
              >
                Cancel
              </button>
              <button
                onClick={startMeeting}
                className="bg-blue-600 hover:bg-blue-800 text-white font-semibold py-2 px-4 rounded-lg shadow transition duration-300"
              >
                {isJoining ? "Join" : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MeetingHome;
